import React from 'react';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';

/**
 * Cart page while it loads: CheckoutPage's summary step, with two cart items beside the Cart Summary panel
 * (stacked below lg, where the guarantee and voucher form come first). The cart is client-side, so no slots.
 */
export default function CheckoutPageSkeleton() {
  return (
    <div className="CheckoutPageSkeleton container">
      <SkeletonBlock className="CheckoutPageSkeleton__title d-none d-lg-block" />

      <div className="CheckoutPageSkeleton__main">
        <div className="CheckoutPageSkeleton__items">
          <SkeletonBlock className="CheckoutPageSkeleton__item" />
          <SkeletonBlock className="CheckoutPageSkeleton__item" />
          <SkeletonBlock className="CheckoutPageSkeleton__bar d-lg-none" />
          <SkeletonBlock className="CheckoutPageSkeleton__bar d-lg-none" />
        </div>

        <div className="CheckoutPageSkeleton__side">
          <SkeletonBlock className="CheckoutPageSkeleton__summary" />
          <SkeletonBlock className="CheckoutPageSkeleton__guarantee d-none d-lg-block" />
        </div>
      </div>
    </div>
  );
}
